export const USER_BETA_FEATURES = {
  USER_BETA_FEATURE_ONLYOFFICE: 'onlyoffice',
  USER_BETA_FEATURE_DEEPMAIL: 'deepmail',
} as const
